import {createSlice} from '@reduxjs/toolkit';

const internalCandidateStaticSlice = createSlice ({
  name: 'internalCandidateStatic',
  initialState: {
    data: null,
    educationData: null,
    peviousExperienceData: null,
    officialReferenceData: null,
    status: 'idle',
    error: null,
  },
  reducers: {
    addPersonalDetails: (state, action) => {
      state.data = action.payload;
    },
    addEducationSkill: (state, action) => {
      state.educationData = action.payload;
    },
    addPreviousExperience: (state, action) => {
      state.peviousExperienceData = action.payload;
    },
    addOfficialReference: (state, action) => {
      state.officialReferenceData = action.payload;
    },
    removePersonalDetails: (state, action) => {
      state.data = null;
    },
    removeEducationSkill: (state, action) => {
      state.educationData = null;
    },
    removePreviousExperience: (state, action) => {
      state.peviousExperienceData = null;
    },
    removeOfficialReference: (state, action) => {
      state.officialReferenceData = null;
    },
  },
});

export const {
  addPersonalDetails,
  removePersonalDetails,
  removeEducationSkill,
  addEducationSkill,
  addPreviousExperience,
  removePreviousExperience,
  addOfficialReference,
  removeOfficialReference
} = internalCandidateStaticSlice.actions;

export default internalCandidateStaticSlice.reducer;
